import React from 'react';
import {FormattedMessage} from 'react-intl';

const STUDIO = 'listings.capacity.studio.short';
const ONE_BEDROOM = 'listings.capacity.bedroom.short';
const MANY_BEDROOMS = 'listings.capacity.bedrooms.short';
const ONE_BATHROOM = 'listings.capacity.bathroom.short';
const MANY_BATHROOMS = 'listings.capacity.bathrooms.short';
const ONE_GUEST = 'listings.capacity.guest.short';
const MANY_GUESTS = 'listings.capacity.guests.short';

function convertToString(x) {
    return `${x}`;
}

function getBedroomKey(count) {
    switch (count) {
        case 0:
            return STUDIO;

        case 1:
            return ONE_BEDROOM;

        default:
            return MANY_BEDROOMS;
    }
}

function getBathroomKey(count) {
    return (count === 1)
        ? ONE_BATHROOM
        : MANY_BATHROOMS;
}

function getGuestKey(count) {
    return (count === 1)
        ? ONE_GUEST
        : MANY_GUESTS;
}

export default function CardDescription({bedroomCount, bathroomCount, guestCount}) {
    return (
        <div className="great-place__card__description">
            <FormattedMessage
                id={getBedroomKey(bedroomCount)}
                values={{count: convertToString(bedroomCount)}}
            />
            {' • '}
            <FormattedMessage
                id={getBathroomKey(bathroomCount)}
                values={{count: convertToString(bathroomCount)}}
            />
            {' • '}
            <FormattedMessage
                id={getGuestKey(guestCount)}
                values={{count: convertToString(guestCount)}}
            />
        </div>
    );
}
